/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-04-02 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { OnboardingNewFeatureStep } from 'src/constants/dashboard-layout.js';
import { updateTenantApp } from 'actions/oauth-actions';
import StepOne from './step-one';
import StepTwo from './step-two';
import StepThree from './step-three';
import StepFour from './step-four';
import StepFive from './step-five';
import history from 'src/routes/history';
import { routes } from 'src/routes';

import * as commonAction from 'src/stores/actions/common-actions.js';

class NewFeatureOnboard extends Component<Props> {
  state = {
    currentStep: 0,
    onboardingStep: 0
  };

  async componentDidMount() {
    const { installStatus, isOnboardingV3 } = this.props;
    // Set status welcome onboard new feature for all old customers
    if (!OnboardingNewFeatureStep.includes(installStatus) && !isOnboardingV3) {
      await updateTenantApp({ installStatus: OnboardingNewFeatureStep[0] });
      this.setState({ currentStep: 0, onboardingStep: 0 });
    } else {
      // Get current status onboarding new feature
      if (!isOnboardingV3) {
        const currentStep = OnboardingNewFeatureStep.findIndex(e => e === installStatus);
        this.setState({ currentStep, onboardingStep: currentStep });
        // Set step = 6 => status done => don't show onboarding for new user
      } else {
        this.setState({ currentStep: 6, onboardingStep: 6 });
        history.push(routes.dashboard.view());
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    const { updateTenantAppLoading: loadingPrev } = this.props;
    const {
      updateTenantAppLoading: loading,
      // recentInstalledAt,
      installStatus,
      isOnboardingV3
    } = nextProps;

    if (loadingPrev === true && loading === false) {
      // Get current status onboarding new feature
      if (!isOnboardingV3) {
        const onboardingStep = OnboardingNewFeatureStep.findIndex(e => e === installStatus);
        this.setState({ onboardingStep });
        // Set step = 6 => status done => don't show onboarding for new user
      } else this.setState({ onboardingStep: 6 });
    }
  }
  render() {
    const { currentStep } = this.state;
    const { enableNewFeatureOnboarding } = this.props;
    const stepComponent = [
      <StepOne updateStep={this.updateStep} />,
      <StepTwo updateStep={this.updateStep} />,
      <StepThree updateStep={this.updateStep} />,
      <StepFour updateStep={this.updateStep} />,
      <StepFive
        updateStep={this.updateStep}
        enableNewFeatureOnboarding={enableNewFeatureOnboarding}
      />
    ];
    return <div className="BC-Page">{stepComponent[currentStep]}</div>;
  }

  updateStep = step => {
    const { onboardingStep } = this.state;
    this.setState({ currentStep: step });

    if (step > onboardingStep) {
      this.handleChangeStepOnboardingNewFeature(step);
    }
  };

  handleChangeStepOnboardingNewFeature = index => {
    const { updateTenantApp } = this.props;
    const stepName = OnboardingNewFeatureStep[index];
    updateTenantApp({ installStatus: stepName });
  };
}

const mapStateToProps = (state, props) => ({
  installStatus: _.get(state.oauth, 'tenantApp.installStatus', ''),
  userAppVersion: _.get(state.oauth, 'tenantApp.userAppVersion', ''),
  isOnboardingV3: _.get(state.oauth, 'tenantApp.settings.onboardingV3.settings.enable', false),
  recentInstalledAt: _.get(state.oauth, 'tenantApp.recentInstalledAt', ''),
  updateTenantAppLoading: _.get(state.oauth, 'loadingUpdate', false)
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateTenantApp: body => dispatch(updateTenantApp(body, undefined, ownProps.i18n)),
  enableNewFeatureOnboarding: (enable, source, action) =>
    dispatch(commonAction.enableNewFeatureOnboarding(enable, source, action, ownProps))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(NewFeatureOnboard));
